module.exports = __webpack_public_path__ + "img/wa07.a9d7eb2f.jpg";